/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable measurabilities
import { tableSchemaBase as columns } from '../measurabilities.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IMeasurabilitiesDatatableSlice {
	measurabilitiesDatatableOptions: TColumnsSchema[];
	setMeasurabilitiesDatatableOptions: (
		_measurabilitiesDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeMeasurabilitiesDatatableSlice = (
	s: any
): any => ({
	measurabilitiesDatatableOptions:
		s.measurabilitiesDatatableOptions,
});

const initialState = {
	measurabilitiesDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createMeasurabilitiesDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IMeasurabilitiesDatatableSlice
> = (set) => ({
	...initialState,
	setMeasurabilitiesDatatableOptions: (
		_measurabilitiesDatatableOptions: TColumnsSchema[]
	) =>
		set({
			measurabilitiesDatatableOptions:
				_measurabilitiesDatatableOptions,
		}),
});
